import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {Flex, Skeleton} from "antd";
import AdsBanner from "../../../../shared/components/adsBanner/AdsBanner";
import ProductCard from "../../../../shared/components/productCard/ProductCard";
import {BookmarkListProps} from "../../models";
import {getBookmarkList} from "../../actions/Bookmark.action";
import {useLocation} from "react-router-dom";
import {EmptyMessage} from "../../../../shared";
import BookMarkListHeader from "../../components/bookmarkListHeader/BookMarkListHeader";

const BookmarkList = ({getBookmarkList} : BookmarkListProps) => {
    const [products, setProducts] =
        useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const location = useLocation()
    const getList = () => {
        setLoading(true)
        getBookmarkList()
            .then((data: any) => {
                if (data.payload != undefined) {

                    setProducts(data.payload.data);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        getList();
    }, []);
    return (
        <Flex vertical gap={"small"}>
            <BookMarkListHeader />
            {(products?.length === 0 && !loading) && <EmptyMessage message={"آگهی در حال حاضر موجود نیست !"}/>}
            {loading ?<Flex vertical >
                    <Skeleton round active/>
                    <Skeleton round active/>
                    <Skeleton round active/>
                </Flex> :
                products.map((item:any) => <ProductCard product={item}/>)
            }


        </Flex>
    );
};

export default connect(null, {getBookmarkList})(withRouter(BookmarkList));
